import {
  ProformaInvoiceFormGroupByMode,
  ProformaInvoiceFormViewMode
} from '../../ProformaInvoiceForm.types';
import { GroupedItemsGroupByEnum } from '../../../../../../groupedItems/groupedItemsTypes';

interface GetGroupByFromViewModeOptions {
  viewMode: ProformaInvoiceFormViewMode;
  groupByMode: ProformaInvoiceFormGroupByMode;
  enableGrouping: boolean;
  mergeSimilar: boolean;
  withItemGroup?: boolean;
  withItemSplit?: boolean;
  cacheApiEnabled?: boolean;
}

function getGroupByFromViewMode({
  viewMode,
  groupByMode,
  enableGrouping,
  mergeSimilar,
  withItemGroup,
  withItemSplit,
  cacheApiEnabled
}: GetGroupByFromViewModeOptions) {
  const groupBy: Set<GroupedItemsGroupByEnum> = new Set();

  const projectValue = cacheApiEnabled
    ? GroupedItemsGroupByEnum.ROOT_PROJECT
    : GroupedItemsGroupByEnum.PROJECT;

  switch (viewMode) {
    case ProformaInvoiceFormViewMode.INVOICES:
      (mergeSimilar || !withItemGroup) &&
        groupBy.add(GroupedItemsGroupByEnum.ITEM);
      withItemGroup && groupBy.add(GroupedItemsGroupByEnum.ITEM_GROUP);
      withItemSplit && groupBy.add(GroupedItemsGroupByEnum.SPLIT);
      break;

    case ProformaInvoiceFormViewMode.TASKS:
      groupBy.add(GroupedItemsGroupByEnum.TASK);
      break;

    case ProformaInvoiceFormViewMode.GROUPS:
      groupBy.add(GroupedItemsGroupByEnum.PROJECT);
      break;

    case ProformaInvoiceFormViewMode.PROJECTS:
      groupBy.add(projectValue);
      break;

    case ProformaInvoiceFormViewMode.CATEGORIES:
      groupBy.add(GroupedItemsGroupByEnum.CATEGORY);
      break;
  }

  if (!enableGrouping) {
    return Array.from(groupBy);
  }

  switch (groupByMode) {
    case ProformaInvoiceFormGroupByMode.SPLIT:
      groupBy.add(GroupedItemsGroupByEnum.SPLIT);
      break;

    case ProformaInvoiceFormGroupByMode.TASK:
      groupBy.add(GroupedItemsGroupByEnum.TASK);
      break;

    case ProformaInvoiceFormGroupByMode.GROUP:
      groupBy.add(GroupedItemsGroupByEnum.FIRST_SUBPROJECT);
      break;

    case ProformaInvoiceFormGroupByMode.PROJECT:
      groupBy.add(projectValue);
      break;

    case ProformaInvoiceFormGroupByMode.PROJECT_TASK:
      groupBy.add(projectValue);
      groupBy.add(GroupedItemsGroupByEnum.TASK);
      break;

    case ProformaInvoiceFormGroupByMode.PROJECT_GROUP:
      groupBy.add(projectValue);
      groupBy.add(GroupedItemsGroupByEnum.PROJECT);
      break;

    case ProformaInvoiceFormGroupByMode.PROJECT_GROUP_TASK:
      groupBy.add(projectValue);
      groupBy.add(GroupedItemsGroupByEnum.PROJECT);
      groupBy.add(GroupedItemsGroupByEnum.TASK);
      break;

    case ProformaInvoiceFormGroupByMode.GROUP_TASK:
      groupBy.add(GroupedItemsGroupByEnum.PROJECT);
      groupBy.add(GroupedItemsGroupByEnum.TASK);
      break;

    case ProformaInvoiceFormGroupByMode.PROJECT_SPLIT:
      groupBy.add(projectValue);
      groupBy.add(GroupedItemsGroupByEnum.SPLIT);
      break;

    case ProformaInvoiceFormGroupByMode.BATCH:
      groupBy.add(GroupedItemsGroupByEnum.BATCH);
      break;

    case ProformaInvoiceFormGroupByMode.BATCH_TASK:
      groupBy.add(GroupedItemsGroupByEnum.BATCH);
      groupBy.add(GroupedItemsGroupByEnum.TASK);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_INVOICE_CREATED:
      groupBy.add(GroupedItemsGroupByEnum.INVOICE_CREATION_MONTH);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_TASK_CREATED_TASK:
      groupBy.add(GroupedItemsGroupByEnum.TASK);
      groupBy.add(GroupedItemsGroupByEnum.DATE);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_TASK_DUE_DATE_TASK:
      groupBy.add(GroupedItemsGroupByEnum.TASK);
      groupBy.add(GroupedItemsGroupByEnum.TASK_DUE_MONTH);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_PROJECT_CREATED_PROJECT:
      groupBy.add(projectValue);
      groupBy.add(GroupedItemsGroupByEnum.DATE);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_TASK_CREATED:
      groupBy.add(GroupedItemsGroupByEnum.TASK);
      groupBy.add(GroupedItemsGroupByEnum.DATE);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_TASK_DUE_DATE:
      groupBy.add(GroupedItemsGroupByEnum.TASK);
      groupBy.add(GroupedItemsGroupByEnum.TASK_DUE_MONTH);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_PROJECT_CREATED:
      groupBy.add(projectValue);
      groupBy.add(GroupedItemsGroupByEnum.DATE);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_PROJECT_CLOSED:
      groupBy.add(projectValue);

      !cacheApiEnabled &&
        groupBy.add(GroupedItemsGroupByEnum.PROJECT_CLOSURE_MONTH);
      break;

    case ProformaInvoiceFormGroupByMode.INVOICE_TAG:
      groupBy.add(GroupedItemsGroupByEnum.INVOICE_TAG);
      break;
  }

  return Array.from(groupBy);
}

export default getGroupByFromViewMode;
